import { Component } from '@angular/core';

@Component({
  selector: 'lib-card-list-header',
  templateUrl: './card-list-header.component.html',
  styleUrls: ['./card-list-header.component.scss'],
})
export class CardListHeaderComponent {}
